module.exports = __webpack_public_path__ + "static/media/hush.78bc1743.svg";